import React, { ReactNode } from "react"
import Drawer, { DrawerProps } from "../drawer"
import Detail, { DetailProps } from "./Detail"
import { useToggle } from "ahooks/lib"
import Button from "../button"

interface Props extends DetailProps {
  title: string
  onClose: () => void
  drawerProps?: Omit<DrawerProps, 'trigger'>
  buttonType?: "primary" | "default" | "dashed" | "link" | "text",
  buttonText?: string | ReactNode,
}

const DrawerDetail: React.FC<Props> = ({ title, onClose, buttonType, buttonText, drawerProps, ...props }) => {
  const [open, { toggle }] = useToggle(drawerProps?.open || false)
  const handleClose = () => {
    toggle()
    drawerProps?.onClose?.()
  }

  return (
    <>
      <Button type={buttonType} onClick={toggle}>
        {buttonText}
      </Button>
      <Drawer
        open={open}
        title={title}
        onClose={handleClose}
        destroyOnClose
      >
        <Detail
          card={false}
          bordered={false}
          layout={'vertical'}
          colon={false}
          {...props}
        />
      </Drawer>
    </>
  )
}

export default DrawerDetail
